module.exports = __webpack_public_path__ + "static/pic03-065134e62470b7e0e40e794d1dd07ed1.jpg";